<template>
    <v-dialog
      v-model="isErrored"
      max-width="500"
    >
      <v-card>
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="red darken-1" x-large>mdi-alert-circle</v-icon></div>
          <p show="valiErrorText" v-html="valiErrorText"></p>
        </v-card-text>

        <v-card-actions class="px-8">
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            block
            @click="isErrored=false"
            class="white--text mb-5"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["valiErrorText"],  
    data: () => ({
        isErrored: false,
    }),
  methods: {
    open() {
      this.isErrored = true;
    }
  }
}
</script>

